import { getDictPhrase } from "../../../common";
import { isDeadHeatRuleApplied, isRuleDeductionApplied } from "../../selection";
export const getBetRulesMessages = (bet, state) => {
    let ruleMessages = [];
    isDeadHeatRuleApplied(bet) && ruleMessages.push(getDictPhrase(state.dict, "DeadHeatRule"));
    isRuleDeductionApplied(bet) && ruleMessages.push(getDictPhrase(state.dict, "Rule4Deduction"));
    return ruleMessages.length ? ` (${ruleMessages.join(" ")})` : "";
};
//# sourceMappingURL=getBetRulesMessages.js.map